<div class="container-modal">
  <div class="cancelar"><p (click)="closeModal()">X</p></div>
  <div class="avatar-information">
    <div class="profile-icon">
      <p class="ion-text-center" aria-disabled="true"> {{
        getInitials(
          name + " " +lastName
        )
      }}</p>
    </div>
    <p class="name">{{name}} {{lastName}}</p>
  </div>
  <div class="toggle" *ngIf="isSystemAdmin">
    <p>Licencia</p>
    <ion-toggle [color]="'tertiary'" [(ngModel)]="hasLicense" (ionChange)="updateLicense()"></ion-toggle>
  </div>
  <div class="permisos" (click)="openmodal()">
    <ion-icon name="create-outline"></ion-icon>
    <p> Editar Permisos</p>
  </div>
</div>
